import { Component } from '@angular/core';

@Component({
  selector: 'pbk-input',
  templateUrl: './forbidden-page.component.html',
})
export class ForbiddenPageComponent {}
